import dayJs from 'src/Helpers/dayjs'
import { APP } from 'src/Configs/App'

interface ShouldShowNewLabelParams {
  campaignsCount: number
  userCreatedAt: string
}

export const shouldShowNewLabel = ({
  campaignsCount,
  userCreatedAt,
}: ShouldShowNewLabelParams): boolean =>
  Boolean(APP.PRE_RELEASE_NEW_LABEL_CUTOFF_DATE) &&
  campaignsCount > 0 &&
  dayJs(userCreatedAt).isBefore(dayJs(APP.PRE_RELEASE_NEW_LABEL_CUTOFF_DATE))
